import { render, staticRenderFns } from "./GoogleMyBusiness.vue?vue&type=template&id=4fe1baf8&scoped=true&"
import script from "./GoogleMyBusiness.vue?vue&type=script&lang=js&"
export * from "./GoogleMyBusiness.vue?vue&type=script&lang=js&"
import style0 from "./GoogleMyBusiness.vue?vue&type=style&index=0&id=4fe1baf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe1baf8",
  null
  
)

export default component.exports